<div class="mat-form-field upload-photo" [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize  : field.label.length > 100 ?
  'col-md-12': field.label.length > 50 ?
  'col-md-6' :  field.label.length > 30 ?
  'col-md-4' :'col-md-3'" [formGroup]="group" appearance="fill" [matTooltip]="field.hint"
  [matTooltipDisabled]="!field.hint" matTooltipPosition="above" matTooltipClass="sbm-tooltip">

  <div class="file-upload" *ngIf="!group.get(this.field.name).value">
    <label>
      <app-required *ngIf="isRequired()"></app-required>
      <ng-container *ngIf="field?.sequence>=0 && !field?.hideSequence"> {{field?.sequence + 1}}) </ng-container>
      {{field.label}}
    </label>
    <input type="file" [accept]="fileTypes" [disabled]="group.get(this.field.name).disabled" [formControl]="control"
      (change)="onSelectedFile($event)" />
  </div>

  <div class="hint pl-2 p-1" *ngIf="field.hint">{{field.hint}}</div>
  <div class="downlaodlnk form-control" *ngIf="group.get(this.field.name).value">
    <a href="javascript: void(0);" (click)="getFile()"> <i class="fa fa-download"></i> View/Download File</a>
    <button (click)="removeFile()" class="btn btn-danger" matTooltip="Remove this File" type="button"
      *ngIf="!group.get(this.field.name).disabled" matTooltipPosition="below" style="padding: 7px;">
      <mat-icon style="transform: scale(0.7)">close</mat-icon>
    </button>
  </div>
</div>
